import Swiper, { Navigation, Thumbs, EffectFade, Grid, Pagination } from 'swiper';

export default class Gallery {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;

        this.init();
    }

    init() {
        const modal = this.el.querySelector('#gallery-modal');
        const btnNext = this.el.querySelector('.gallery__btn-next');
        const btnPrev = this.el.querySelector('.gallery__btn-prev');
        const galleryClose = this.el.querySelector('#gallery-close');
        const thumbsSwiper = this.el.querySelector('.gallery-modal__thumbs');
        const modalMainSwiper = this.el.querySelector('.gallery-modal__main');
 
        const swiper = new Swiper('.gallery__slider', {
            modules: [Grid, Navigation, Pagination],
            slidesPerView: 3,
            slidesPerGroup: 1,
            grid: {
                rows: 3,
                fill: 'row',
            },
            spaceBetween: 10,
            pagination: {
                el: '.gallery__pagination',
                clickable: true,
                bulletClass: 'gallery__pagination-bullet',
                bulletActiveClass: 'gallery__pagination-bullet-active',
            },
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            breakpoints: {
                767: {
                    spaceBetween: 15,
                    grid: {
                        rows: 3,
                        fill: 'row',
                    },
                    slidesPerView: 5,
                },
            }
        });

        function updateButtons() {
            if (swiper.isBeginning && btnPrev) {
                btnPrev.classList.add('disabled');
            } else {
                btnPrev.classList.remove('disabled');
            }

            if (swiper.isEnd && btnNext) {
                btnNext.classList.add('disabled');
            } else {
                btnNext.classList.remove('disabled');
            }
        }

        updateButtons();
        swiper.on('slideChange', updateButtons);
        
        const galleryThumbs = new Swiper(thumbsSwiper, {
            modules: [Thumbs],
            slidesPerView: 5,
            spaceBetween: 15,
            centeredSlides: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            loop: false,
            breakpoints: {
                767: {
                   slidesPerView: 10, 
                }
            }
        });

        const galleryMain = new Swiper(modalMainSwiper, {
            modules: [Navigation, Thumbs, EffectFade],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            navigation: {
                nextEl: '#gallery-next',
                prevEl: '#gallery-prev',
            },
            thumbs: { swiper: galleryThumbs },
            on: {
                slideChange(instance) {
                    galleryThumbs.slideTo(instance.activeIndex, 300);
                }
            }
        });

       document.querySelectorAll('.gallery__item a').forEach((link, index) => {
            link.addEventListener('click', e => {
                e.preventDefault();
                modal.classList.add('active');
                galleryMain.slideTo(index, 0);
                galleryThumbs.slideTo(index, 0, false);
            });
        });

        galleryClose.addEventListener('click', () => {
            modal.classList.remove('active');
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                modal.classList.remove('active');
            }
        });
    }
}
